import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPrograms } from "../../redux/program/programActions";
import { fetchSubjects } from "../../redux/subject/subjectActions";
import { fetchEvaluationTypes } from "../../redux/evaluationType/evaluationTypeActions";
import { Link } from "react-router-dom";
import { FaSearch } from "react-icons/fa";
import Loader from "../../components/Loader/Loader";
import AssessmentFilter from "../AssessmentMarking/AssessmentFilter";
import "./Exam.css";
import {
  getProgramWiseSubjectList,
  getProgramWiseExamList,
  bulkExamCreate,
} from "../../services/ExamService";
import {
  getExamConfigs,
  getFilteredExamConfigs,
} from "../../services/ExamConfigService";
import { getSubjects } from "../../services/SubjectServices";
import { getAssessmentLists } from "../../services/AssessmentListService";
import { getPreviousTerm, getTermLabel } from "../../utils/helper";
import { enqueueSnackbar } from "notistack";
import Pagination from "../../components/Pagination/Pagination";
import { useNavigate } from "react-router-dom";
import Input from "../../components/Input/Input";
import Button from "../../components/Button/Button";
import { Form, Alert } from "react-bootstrap";
import Table from "../../components/Table/Table";
import { tableConstants } from "./ExamBulkTableConstant";

const ExamBulkCreate = () => {
  const [subjectData, setSubjectData] = useState([]);
  const [exam_ids, setExamIds] = useState([]);
  const [id, setId] = useState(null);
  const [examList, setExamList] = useState([]);
  const [eventData, setEventData] = useState([]);
  const [program_id, setProgramID] = useState("");
  const [subject_id, setSubjectID] = useState("");
  const [evaluation_type_id, setEvaluationTypeID] = useState("");
  const [status, setStatus] = useState("");
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [name, setName] = useState("");
  const [term, setTerm] = useState("");
  const [advancedSearch, setAdvancedSearch] = useState(false);
  const [loading, setIsLoader] = useState(false);
  const [search, setSearch] = useState(false);
  const [current_page, setCurrentPage] = useState(1);
  const [last_page, setLastPage] = useState(1);
  const [globalDate, setGlobalDate] = useState(false);
  const [globalStartDate, setGlobalStartDate] = useState("");
  const [globalEndDate, setGlobalEndDate] = useState("");
  const [, setExamFailedData] = useState([]);
  const [errorMap, setErrorMap] = useState({});
  const [rowResultMap, setRowResultMap] = useState({});
  const [prevTermWarnings, setPrevTermWarnings] = useState([]);
  const org_id = localStorage.getItem("organization_id");
  const session_id = localStorage.getItem("session_id");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const programData = useSelector((state) => state.program.programs.data);
  const [exam, setExam] = useState([]);
  const evaluationType = useSelector(
    (state) => state.evaluationType.evaluationTypes.data
  );
  const [programs, setPrograms] = useState([]);

  useEffect(() => {
    if (!org_id || !session_id) return;
    dispatch(fetchPrograms());
    dispatch(fetchSubjects({ selected: 0 }));
    dispatch(fetchEvaluationTypes());
    getExamConfigList({ selected: 0 });
    getAllSubjectsAndExams();
  }, [dispatch, org_id, session_id]);

  // Load all subjects and exam headers so filters work without selecting a class
  const getAllSubjectsAndExams = async () => {
    try {
      const [subjectRes, examRes] = await Promise.all([
        getSubjects(),
        getAssessmentLists(),
      ]);
      setSubjectData(subjectRes?.data || []);
      setExamList(examRes?.data?.data || []);
    } catch (error) {
      console.error(error);
    }
  };

  const getExamConfigList = async ({ selected }) => {
    let current_page = selected + 1;
    try {
      setIsLoader(true);
      setCurrentPage(current_page);
      const response = await getExamConfigs(current_page);
      if (response.status === 200) {
        const eventData = response.data.data;
        let last_page = response.data.last_page;
        setEventData(eventData);
        setLastPage(last_page);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoader(false);
    }
  };

  const getSubjectList = async (id) => {
    try {
      const response = await getProgramWiseSubjectList(id);
      if (response.status === 200) {
        const subjectData = response.data.data;
        setSubjectData(subjectData);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleSearch = useCallback(
    async ({ selected }) => {
      const page = selected + 1;
      try {
        setSearch(true);
        setIsLoader(true);
        setCurrentPage(page);
        let program_ids = programs && programs.map((item) => item.id);
        const response = await getFilteredExamConfigs(
          name,
          program_ids,
          subject_id,
          evaluation_type_id,
          start,
          end,
          term,
          status,
          page
        );
        if (response.status === 200) {
          const { data, last_page } = response.data;
          setEventData(data);
          setLastPage(last_page);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoader(false);
      }
    },
    [
      programs,
      subject_id,
      evaluation_type_id,
      name,
      start,
      end,
      term,
      status,
    ]
  );
  // <--- Make sure the dependencies are correctly listed

  const handleReset = (event) => {
    event.preventDefault();
    setProgramID("");
    setSubjectID("");
    setName("");
    setEvaluationTypeID("");
    setStart("");
    setEnd("");
    setTerm("");
    setStatus("");
    getExamConfigList({ selected: 0 });
    getAllSubjectsAndExams();
    setPrograms([]);
  };

  const getExamList = async (program_id) => {
    try {
      const response = await getProgramWiseExamList(program_id);
      if (response.status === 200) {
        const examList = response.data.data;
        setExamList(examList);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const advancedSearchHandler = (e) => {
    e.preventDefault();
    setAdvancedSearch(!advancedSearch);
  };

  const handleInputChange = (event, incomingExam) => {
    const { value, checked } = event.target;
    const exam_id = value;
    let traits_data = [];
    if (incomingExam.is_traits) {
      traits_data =
        incomingExam.traits &&
        incomingExam.traits.map((trait) => ({
          trait_id: trait.subject_trait.id,
          trait_position: trait.trait_position,
          max_score: trait.max_score,
          grade_scheme_id: trait.grade_scheme.id,
        }));
    }
    let obj = {
      id: exam_id,
      name: incomingExam.name.id,
      term: incomingExam.term,
      session_id: session_id,
      program_id: incomingExam.program.id,
      subject_id: incomingExam.subject.id,
      evaluation_type_id: incomingExam.evaluation_type.id,
      max_score: incomingExam.max_score,
      grade_scheme_id: incomingExam.grade_scheme.id,
      status: 1,
      is_active: incomingExam.is_active,
      total_attempts: incomingExam.total_attempts,
      start: incomingExam.start,
      end: incomingExam.end,
      is_traits: incomingExam.is_traits,
      attempts: incomingExam.attempts,
      description: incomingExam.description,
      grade_method: incomingExam.grade_method,
      traits: traits_data,
    };

    if (checked) {
      setExamIds([...exam_ids, exam_id]);
      setExam([...exam, obj]);
    } else {
      const updatedStudentIds = exam_ids.filter((id) => id !== exam_id);
      setExamIds(updatedStudentIds);
      const updatedExam = exam.filter((item) => item.id !== exam_id);
      setExam(updatedExam);
    }
  };

  const selectAllExam = (event) => {
    const exam_ids = [];
    const examData = [];
    if (event.target.checked) {
      eventData.forEach((exam) => {
        const id = exam.id.toString();
        document.getElementById(id).checked = true;
        exam_ids.push(id);
        let traits_data = [];
        if (exam.is_traits) {
          traits_data = exam.traits.map((trait) => ({
            trait_id: trait.subject_trait.id,
            trait_position: trait.trait_position,
            max_score: trait.max_score,
            grade_scheme_id: trait.grade_scheme.id,
          }));
        }
        let obj = {
          id: id,
          name: exam.name.id,
          term: exam.term,
          session_id: session_id,
          program_id: exam.program.id,
          subject_id: exam.subject.id,
          evaluation_type_id: exam.evaluation_type.id,
          max_score: exam.max_score,
          grade_scheme_id: exam.grade_scheme.id,
          status: 1,
          is_active: exam.is_active,
          total_attempts: exam.total_attempts,
          start: exam.start,
          end: exam.end,
          grade_method: exam.grade_method,
          is_traits: exam.is_traits,
          attempts: exam.attempts,
          description: exam.description,
          traits: traits_data,
        };
        examData.push(obj);
      });
    } else {
      eventData.forEach((student) => {
        const id = student.id;
        document.getElementById(id).checked = false;
      });
    }
    setExam(examData);
    setExamIds(exam_ids);
  };

  const onProgramSelect = (event) => {
    setPrograms(event);
    if (event && event.length > 0 && event[0]) {
      getExamList(event[0].id); // Assuming event is an array of selected programs
      getSubjectList(event[0].id); // Assuming event is an array of selected programs
    }
  };

  const onProgramRemove = (event) => {
    setPrograms(event);
    if (event.length > 0) {
      getExamList(event[0].id); // Assuming event is an array of selected programs
      getSubjectList(event[0].id); // Assuming event is an array of selected programs
    } else {
      getAllSubjectsAndExams();
    }
  };

  const changeHandler = (e) => {
    const { name, value } = e.target;
    if (name === "program_id") {
      setExamList([]);
      setSubjectData([]);
      setProgramID(value);
      if (value) {
        getExamList(value);
        getSubjectList(value);
      } else {
        getAllSubjectsAndExams();
      }
    } else if (name === "subject_id") {
      setSubjectID(value);
    } else if (name === "name") {
      setName(value);
    } else if (name === "evaluation_type_id") {
      setEvaluationTypeID(value);
    } else if (name === "term") {
      setTerm(value);
    } else if (name === "status") {
      setStatus(value);
    }
  };



  // Fetches every exam-config row for a given class + term (paging through all results),
  // used to check whether the immediately preceding exam level is configured.
  const fetchAllExamConfigsForProgramTerm = async (program_id, term) => {
    let page = 1;
    let all = [];
    try {
      while (true) {
        const response = await getFilteredExamConfigs(
          "",
          [program_id],
          "",
          "",
          "",
          "",
          term,
          "",
          page
        );
        if (response.status !== 200) break;
        const data = response.data?.data || [];
        const last_page = response.data?.last_page || 1;
        all = all.concat(data);
        if (page >= last_page) break;
        page += 1;
      }
    } catch (error) {
      console.error(error);
    }
    return all;
  };

  // Warns (without blocking) when a subject has a configuration for the immediately
  // preceding exam level (e.g. PT-1) but not for the level being bulk-created (e.g. PT-2).
  // Only checks configurations (event_configs) — never whether an actual exam/event
  // was created. If the level being created already has a configuration for a subject,
  // that subject is never warned about.
  const checkPreviousTermWarnings = async () => {
    const groups = {};
    exam.forEach((item) => {
      const key = `${item.program_id}|${item.term}`;
      if (!groups[key]) {
        groups[key] = {
          program_id: item.program_id,
          term: item.term,
          subjectIds: new Set(),
        };
      }
      groups[key].subjectIds.add(String(item.subject_id));
    });

    const warnings = [];
    for (const { program_id, term, subjectIds } of Object.values(groups)) {
      const prevTerm = getPreviousTerm(term);
      if (!prevTerm) continue;

      const prevConfigs = await fetchAllExamConfigsForProgramTerm(
        program_id,
        prevTerm
      );
      const programName =
        programData?.find((p) => String(p.id) === String(program_id))
          ?.name || `Class #${program_id}`;
      const prevLabel = getTermLabel(prevTerm) || prevTerm;
      const currentLabel = getTermLabel(term) || term;

      if (prevConfigs.length === 0) continue;

      const missingSubjects = [
        ...new Set(
          prevConfigs
            .filter((cfg) => !subjectIds.has(String(cfg.subject?.id)))
            .map((cfg) => cfg.subject?.name)
            .filter(Boolean)
        ),
      ];

      if (missingSubjects.length > 0) {
        warnings.push(
          `${programName}: Subjects configured in ${prevLabel} but missing in ${currentLabel}: ${missingSubjects.join(", ")}.`
        );
      }
    }
    return warnings;
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    setExamFailedData([]);
    setErrorMap({});
    setRowResultMap({});
    if (exam_ids.length === 0) {
      enqueueSnackbar("Please select at least one exam", { variant: "error" });
      return;
    }

    const warnings = await checkPreviousTermWarnings();
    setPrevTermWarnings(warnings);
    warnings.forEach((warning) =>
      enqueueSnackbar(warning, { variant: "warning", autoHideDuration: 8000 })
    );

    try {
      let examInput;
      if (globalStartDate !== "" && globalEndDate !== "" && globalDate) {
        examInput = exam.map((exam) => ({
          ...exam,
          start: globalStartDate,
          end: globalEndDate,
        }));
      } else {
        examInput = exam;
      }
      const response = await bulkExamCreate(examInput);
      if (response.status === 200) {
        const results = response?.data?.data?.results || [];
        const summary = response?.data?.data?.summary || {};
        const hasIssues = results.some(
          (r) =>
            r.status === "existing" ||
            r.status === "skipped" ||
            r.status === "failed"
        );
        if (hasIssues) {
          handleBulkCreateErrors(results, summary, examInput);
        } else {
          enqueueSnackbar("Exam created successfully", { variant: "success" });
          setExam([]);
          setExamIds([]);
          setErrorMap({});
          setPrevTermWarnings([]);
          navigate("/exam/list");
        }
      } else {
        const results = response?.data?.data?.results || [];
        const summary = response?.data?.data?.summary || {};
        handleBulkCreateErrors(results, summary, examInput);
      }
    } catch (error) {
      const examInput =
        globalStartDate !== "" && globalEndDate !== "" && globalDate
          ? exam.map((exam) => ({
              ...exam,
              start: globalStartDate,
              end: globalEndDate,
            }))
          : exam;
      const results = error.response?.data?.data?.results || [];
      const summary = error.response?.data?.data?.summary || {};
      if (results.length > 0) {
        handleBulkCreateErrors(results, summary, examInput);
      } else {
        const fallbackMessage =
          error.response?.data?.message?.errors?.errors ||
          (typeof error.response?.data?.message === "string"
            ? error.response?.data?.message
            : "Failed to create exam");
        enqueueSnackbar(
          typeof fallbackMessage === "string"
            ? fallbackMessage
            : "Failed to create exam",
          { variant: "error" }
        );
      }
    }
  };

  const handleBulkCreateErrors = (results, summary, examInput) => {
    // results[] each has: { row (1-based), status, message, event_name, program_id, subject_id }
    const newErrorMap = {};
    const newRowResultMap = {};

    const findExamByResult = (result) => {
      const zeroIndex = Number(result.row) - 1;
      if (!Number.isNaN(zeroIndex) && examInput[zeroIndex]) {
        return examInput[zeroIndex];
      }

      // Fallback mapping in case backend row index is not aligned with selected order.
      return examInput.find(
        (item) =>
          Number(item.name) === Number(result.event_name) &&
          Number(item.program_id) === Number(result.program_id) &&
          Number(item.subject_id) === Number(result.subject_id)
      );
    };

    results.forEach((result) => {
      const examConfig = findExamByResult(result);
      if (examConfig) {
        const status = result.status || "unknown";
        const msg =
          result.message ||
          (status === "created"
            ? "Event created successfully"
            : status === "existing"
              ? "Event already exists"
              : `Event ${status}`);

        newRowResultMap[examConfig.id] = {
          status,
          message: msg,
        };

        if (status !== "created") {
          const existing = newErrorMap[examConfig.id];
          newErrorMap[examConfig.id] = existing ? `${existing}; ${msg}` : msg;
        }
      }
    });

    setRowResultMap(newRowResultMap);
    setErrorMap(newErrorMap);
    setExamFailedData(results);

    const created = summary.created ?? 0;
    const existing = summary.existing ?? 0;
    const skipped = summary.skipped ?? 0;
    const failed = summary.failed ?? 0;
    const issueCount = existing + skipped + failed;

    if (created > 0 && issueCount > 0) {
      enqueueSnackbar(
        `${created} exam(s) created${existing > 0 ? `, ${existing} existing` : ""}${skipped > 0 ? `, ${skipped} skipped` : ""}${failed > 0 ? `, ${failed} failed` : ""}. See highlighted rows for details.`,
        { variant: "warning", autoHideDuration: 6000 }
      );
    } else if (issueCount > 0) {
      enqueueSnackbar(
        `${existing > 0 ? `${existing} exam(s) already existing` : ""}${skipped > 0 ? `${existing > 0 ? ", " : ""}${skipped} exam(s) skipped` : ""}${failed > 0 ? `${existing > 0 || skipped > 0 ? ", " : ""}${failed} exam(s) failed` : ""}. See highlighted rows for details.`,
        { variant: "error", autoHideDuration: 6000 }
      );
    }
  };

  const removeFailedEvents = () => {
    if (Object.keys(errorMap).length === 0) return;

    // Get the IDs of failed exams from errorMap
    const failedExamIds = Object.keys(errorMap);
    
    // Filter out the failed exams from the exam array
    const updatedExam = exam.filter(
      (examItem) => !failedExamIds.includes(String(examItem.id))
    );
    const updatedExamIds = updatedExam.map(e => e.id);
    
    // Update the state
    setExam(updatedExam);
    setExamIds(updatedExamIds);
    
    // Uncheck the failed checkboxes in the UI
    failedExamIds.forEach((examId) => {
      const checkbox = document.getElementById(examId);
      if (checkbox) {
        checkbox.checked = false;
      }
    });
    
    // Clear error data
    setErrorMap({});
    setRowResultMap({});
    setExamFailedData([]);
    
    enqueueSnackbar(
      `Removed ${failedExamIds.length} failed exam(s). ${updatedExam.length} exam(s) remaining.`,
      { variant: "info" }
    );
  };

  const clearErrors = () => {
    setErrorMap({});
    setRowResultMap({});
    setExamFailedData([]);
  };

  const inputChangeHandler = (e, examData) => {
    const index = eventData.findIndex((exam) => exam.id === examData.id);
    const { name, value } = e.target;
    const updatedExam = [...eventData];
    updatedExam[index][name] = value;
    setEventData(updatedExam);
  };

  const idChangeHandler = (id) => {
    setId(id);
  };

  return (
    <div className="card">
      {loading ? (
        <Loader />
      ) : (
        <div className="">
          <div className="card-header">
            <div className="d-flex justify-content-between">
              <div className="page-title d-flex align-items-center">
                <Button className="btn-success" onClick={advancedSearchHandler}>
                  <FaSearch /> Search
                </Button>
              </div>
              <Link className="btn btn-primary" to="/exam/list">
                Back
              </Link>
            </div>
          </div>
          {prevTermWarnings.length > 0 && (
            <Alert variant="warning" className="mt-3">
              <div className="d-flex justify-content-between align-items-start">
                <div>
                  <strong>⚠️ Possible missing exam configuration</strong>
                  <ul className="mb-0">
                    {prevTermWarnings.map((warning, index) => (
                      <li key={index}>{warning}</li>
                    ))}
                  </ul>
                </div>
                <Button
                  variant="secondary"
                  size="sm"
                  onClick={() => setPrevTermWarnings([])}
                >
                  Dismiss
                </Button>
              </div>
            </Alert>
          )}
          {Object.keys(errorMap).length > 0 && (
            <Alert variant="warning" className="mt-3">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <strong>⚠️ {Object.keys(errorMap).length} exam(s) failed to create.</strong>
                  <br />
                  <small>Failed rows are highlighted in red below. You can remove them and retry with the remaining exams.</small>
                </div>
                <div className="d-flex gap-2">
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={removeFailedEvents}
                  >
                    Remove Failed Exams
                  </Button>
                  <Button
                    variant="secondary"
                    size="sm"
                    onClick={clearErrors}
                  >
                    Clear Errors
                  </Button>
                </div>
              </div>
            </Alert>
          )}

          <div className="card-body">
            <div
              className={`filter-event ${
                advancedSearch ? "show" : "hide"
              } mb-5`}
              id="advanced-search"
            >
              <AssessmentFilter
                evaluationType={evaluationType}
                programData={programData}
                subjectData={subjectData}
                examList={examList}
                subject_id={subject_id}
                program_id={program_id}
                programs={programs}
                onProgramSelect={onProgramSelect}
                onProgramRemove={onProgramRemove}
                evaluation_type_id={evaluation_type_id}
                name={name}
                term={term}
                status={status}
                onChangeHandler={changeHandler}
                handleSearch={handleSearch}
                handleReset={handleReset}
              />
            </div>
            <Form onSubmit={submitHandler}>
              {eventData && eventData.length > 0 ? (
                <div className="evaluating-table event-tablecus">
                  {loading ? (
                    <Loader />
                  ) : (
                    <Table
                      cols={tableConstants(
                        handleInputChange,
                        inputChangeHandler,
                        selectAllExam,
                        idChangeHandler,
                        id,
                        eventData,
                        exam_ids,
                        current_page,
                        errorMap,
                        rowResultMap
                      )}
                      data={eventData}
                      hoverable={true}
                      striped={true}
                      getRowClassName={(rowData) => 
                        errorMap[rowData.id] ? 'table-danger' : ''
                      }
                    />
                  )}
                </div>
              ) : (
                <div className="d-flex justify-content-center">
                  {" "}
                  No data found
                </div>
              )}
              <div className="d-flex justify-content-between mt-2">
                <div className="">
                  <Button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => setGlobalDate(!globalDate)}
                  >
                    SET DATE
                  </Button>
                </div>
                {globalDate && (
                  <React.Fragment>
                    <div className="col-md-3">
                      <Input
                        type="date"
                        name={"globalStartDate"}
                        value={globalStartDate}
                        onChange={(e) => setGlobalStartDate(e.target.value)}
                      />
                    </div>
                    <div className="col-md-3 mx-2">
                      <Input
                        type="date"
                        name={"globalEndDate"}
                        value={globalEndDate}
                        onChange={(e) => setGlobalEndDate(e.target.value)}
                      />
                    </div>
                  </React.Fragment>
                )}
                <div className="">
                  <Button
                    type="submit"
                    disabled={loading}
                    className="btn btn-primary"
                  >
                    Create
                  </Button>
                </div>
              </div>
            </Form>
          </div>
        </div>
      )}
      {eventData && eventData.length > 0 && (
        <div className="card-footer">
          <Pagination
            totalPage={last_page}
            currentPage={current_page - 1}
            handlePageChange={(i) =>
              search ? handleSearch(i) : getExamConfigList(i)
            }
          />
        </div>
      )}
    </div>
  );
};

export default ExamBulkCreate;
